import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import styles from './ModalCloseButton.css';

const cx = classnames.bind(styles);

function ModalCloseButton({onClick, className}) {
    const buttonClasses = cx({
        button: true,
        [className]: Boolean(className)
    });

    const handleClick = () => {
        onClick?.();
    };

    return (
        <Button
            iconLeft={{
                name: 'close',
            }}
            type='tertiary'
            onClick={handleClick}
            className={buttonClasses}
        />
    );
};

ModalCloseButton.defaultProps = {
    className: ''
};

ModalCloseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
};

export {
    ModalCloseButton
};
